import React from 'react';

import { Wrapper } from './DimensionList.styles';
import { DimensionGroup } from '../DimensionGroup';
import { IDimensionSelection, IAllocatedDimensionGroup } from './../types';
import { ICurrencyFormat } from 'utils/types';
import { ScrollWrapper } from '../styles';

interface IProps {
  onSelect(id: IDimensionSelection | null): void;
  selection: IDimensionSelection | null;
  data: IAllocatedDimensionGroup[];
  disableGroupSelection?: boolean;
  format: ICurrencyFormat;
}

interface IState {
  expanded: string | null;
}

export class DimensionList extends React.Component<IProps, IState> {
  state = { expanded: (this.props.data[0] && this.props.data[0].id) || null };

  toggleExpand = (id: string) => {
    const { expanded } = this.state;
    const { onSelect, selection } = this.props;
    const newState = id === expanded ? null : id;

    // Unselect child if parent group get collapsed
    if (selection && selection.rootId && newState !== selection.rootId) {
      onSelect(null);
    }

    this.setState({ expanded: newState });
  };

  render() {
    const { expanded } = this.state;
    const { onSelect, selection, data, disableGroupSelection, format } =
      this.props;

    return (
      <ScrollWrapper>
        <Wrapper>
          {data.map((item) => (
            <DimensionGroup
              key={item.id}
              data={item}
              isExpanded={item.id === expanded}
              onExpand={this.toggleExpand}
              onSelect={onSelect}
              selection={selection}
              disableGroupSelection={disableGroupSelection}
              format={format}
            />
          ))}
        </Wrapper>
      </ScrollWrapper>
    );
  }
}
